import React from "react"
import * as AppConstants from "../../../utility/AppConstants"
import * as Utility from "../../../utility/Utility"
import "Css/table.css"
interface HeaderTotaliProps {
    codIsa: string | null | undefined
    macroarea: string | null | undefined
    anni: string[]
}
export default function HeaderTotaliCPB(props: HeaderTotaliProps) {
    return (
        <>
            <tr>
                <th style={{ width: "20rem" }}>
                    {Utility.getValoreHeader(
                        props.codIsa,
                        props.macroarea,
                        true
                    )}{" "}
                </th>
                <th style={{ width: "25%" }} className="th-statistiche">
                    {props.anni[0]}
                </th>
                <th style={{ width: "25%" }} className="th-statistiche">
                    {props.anni[1]}
                </th>
                <th style={{ width: "25%" }} className="th-statistiche">
                    {props.anni[2]}
                </th>
            </tr>
        </>
    )
}
